<template>
  <div v-if="data" class="grid-wrapper star-rating-grid">
    <template v-for="field in fields">
      <label :key="field">
        {{ field | friendlyDisplayKeys }}
      </label>
      <star-rating
        :key="`${field}-${data[field]}`"
        :rating="data[field]"
        :editable="false"
        :size="size" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'StarRatingGrid',
  props: {
    data: Object,
    size: Number,
  },
  data: () => ({
    fields: [
      'scoreOverall',
      'scoreClarity',
      'scoreGathering',
      'scoreTimeliness',
      'scoreResponsiveness',
    ],
  }),
}
</script>

<style lang="scss" style>
.grid-wrapper {
  width: 100%;
  grid-template-columns: auto auto;
  justify-content: space-between;
  grid-row-gap: 10px;

  label {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
  }
}
</style>
